import React from 'react';

const variantClass = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  danger: 'btn-danger',
  text: 'btn-text',
};

export default function Button({ variant = 'primary', disabled, style, className, children, ...props }) {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`btn ${variantClass[variant]}${className ? ` ${className}` : ''}`}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
}
